import * as React from "react";
const HeadSVG = (props) => (
  <svg
    id="Layer_2"
    data-name="Layer 2"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 119.17 152.43"
    {...props}
  >
    <defs>
      <style>
        {
          "\n      .cls-1 {\n        fill: #fedfc0;\n        fill-rule: evenodd;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 2.07px;\n      }\n    "
        }
      </style>
    </defs>
    <g id="Layer_1-2" data-name="Layer 1">
      <path
        id="path2384"
        fill= "#E0666A"
        d="M10.11,90.62s2.08,11.86,3.37,16.85c1.39,5.36,2.85,12.79,5.62,17.6,3.09,5.38,9.08,11.38,13.85,15.35,3.95,3.29,9.69,7.45,14.6,8.98,6.12,1.91,15.15,2.79,21.34,1.12,3.76-1.01,7.77-4.74,10.86-7.11,5.86-4.51,14.06-10.44,18.34-16.47,2.19-3.08,4.02-7.93,4.87-11.61,1.77-7.67,1.5-26.21,1.5-26.21l-.75,19.47s6.65-5.24,8.61-8.24c2.68-4.1,5.27-10.46,5.62-15.35.27-3.78.82-10.77-2.62-12.35-2.78-1.29-8.98,4.87-8.98,4.87,0,0,5.01-8.08,5.99-11.98,1.97-7.85,2.99-19.18.75-26.95-2.57-8.95-10.24-19.67-17.22-25.83-4.89-4.32-13.11-8.23-19.47-9.73-10.27-2.43-25.02-2.84-35.19,0-9.61,2.68-21.94,9.66-28.45,17.22-3.81,4.43-6.29,12.25-7.49,17.97-1.33,6.38-1.46,15.29-.37,21.71.81,4.84,5.62,15.35,5.62,15.35,0,0-4.96-6.84-7.49-5.62-3.94,1.91-.8,10.24-.37,14.6.55,5.61,1.2,13.52,4.12,18.34.99,1.64,6.74,4.87,6.74,4.87l-3.37-16.85Z"
      />
    </g>
  </svg>
);
export default HeadSVG;
